<template>
  <div>
    <div class="air__utils__heading">
      <h5>Dashboard Analítico</h5>
    </div>
   <list-transactions  />
      
  </div>
</template>
<script>

import ListTransactions from './list-transactions';
import moment from "moment";



export default {
  components: {
    ListTransactions,
   
  },
  data() {
    return {
      dateFormat: 'DD/MM/YYYY',
      monthFormat: 'YYYY/MM',
      dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
    };
  },
  methods: {
    moment,
  },
  
};

</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
